import { ActivitySpinnerSize, ActivitySpinnerWidget, ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogProps, DialogType, DialogUserResizeMode, DialogWidget, TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~common/react/CommonStyles';

import React = require('react');
import { BuyLicensesTelemetryEvent, TelemetryEvents } from '~common/telemetryEvents/TelemetryEvents';
import { Telemetry } from '~commonInfra/services/Telemetry';

import { Messages } from '../../../../codegen/Localize';
import { SessionManagementService } from '../../../../sessionManagement/SessionManagementService';

const webstoreUrl = '{baseUrl}/add-on?site_id={siteUUID}&source=tol';

interface LeavingBuyModalProps {
    onClose: () => void;
    server: SessionManagementService;
}

interface LeavingBuyModalState {
    readonly isSubmitting: boolean;
    readonly isValid: boolean;
}

export class LeavingBuyModal extends React.Component<LeavingBuyModalProps, LeavingBuyModalState>  {

    public constructor(props: LeavingBuyModalProps) {
        super(props);
        this.state = {isSubmitting: false, isValid: false};
    }

    private submitButtonMessageOrSpinner = (): React.ReactNode => {
        return this.state.isSubmitting ?
            <div style={{ marginTop: TabStyles.Spacing.SmallSpace! }}>
                <ActivitySpinnerWidget spinnerSize={ActivitySpinnerSize.Small} testId="submitting" />
            </div>
            : Messages.buyLicensesWebstore();
    }

    private footerContent = (): React.ReactNode => {
        return <DialogFooterButtonsWidget
                buttons={[
                    {
                        handleClick: () => {
                            this.props.onClose();
                        },
                        buttonType: ButtonType.Outline,
                        children: Messages.cancel(),
                        testId: 'leaving-buy-license-dialog-footer-cancel'
                    },
                    {
                        handleClick: this.redirectToWebstore,
                        buttonType: ButtonType.Go,
                        disabled: this.state.isSubmitting,
                        children: this.submitButtonMessageOrSpinner(),
                        testId: 'leaving-buy-license-dialog-footer-confirm'
                    }
                ]}
                testId="leaving-buy-license-dialog-footer"
            />;
    }

    private dialogProps = (): DialogProps => {
        return {
            shouldReturnFocusOnClose: false,
            dialogWidth: 600,
            testId: 'leaving-buy-license-dialog',
            type: DialogType.NormalWithTitleBar,
            title: Messages.buyLicensesBuyMoreLicenses(),
            positioningBehavior: DialogPositioningBehavior.Draggable,
            isModal: true,
            showCloseButton: true,
            onCloseRequest: this.props.onClose,
            showFooter: true,
            footerContent: this.footerContent(),
            userResizeMode: DialogUserResizeMode.NotResizable,
        };
    }

    private redirectToWebstore = (): void => {
        var baseUrl = this.props.server.webstoreUrl();
        var siteUuid = this.props.server.siteUuid();

        var url = webstoreUrl
            .replace('{baseUrl}', baseUrl)
            .replace('{siteUUID}', siteUuid);
        const windowReference = window.open(url, '_blank');

        if (windowReference) {
                Telemetry.sendEvent<BuyLicensesTelemetryEvent>({
                type: TelemetryEvents.BuyLicenses,
                action: 'buy-licenses-button-3-submit',
                siteUuid: siteUuid
            });
        }
        else {
            Telemetry.sendEvent<BuyLicensesTelemetryEvent>({
                type: TelemetryEvents.BuyLicenses,
                action: 'buy-licenses-button-3-submit-failed',
                siteUuid: siteUuid
            });
        }
    }

    private submit = (): void => {
        this.setState({ isSubmitting: true });
    }

    public render(): JSX.Element {
        return <DialogWidget {...this.dialogProps()}>
            <div style={textStyle}>{Messages.buyLicensesLeavingMessage()}</div>
        </DialogWidget>;
    }

}

const textStyle: React.CSSProperties = {
    marginTop: CommonStyles.Sizes.MediumSpace,
    marginBottom: CommonStyles.Sizes.MediumSpace
};
